<template>
    <div class="app-container bj-label-colon label-width-6 bj-el-input-disabled">
      <BjDivider right-fixed style="margin-bottom: 0;">{{ $t('DetailsOfThirdPartySalesOrder.information') }}
        <template slot="button">
          <el-tooltip effect="dark" placement="top" :content="$t('InternalOrder.No')">
            <!-- <BjSelectLov style="margin-left:10px" v-model="outerOrderNo" :placeholder="$t('InternalOrder.No')" :option-list="firstOrderList" @change="getOrderInfo" :clearable="false"/> -->
            <el-select
              v-model="outerOrderNo"
              style="margin-left: 20px;"
              filterable
              remote
              reserve-keyword
              :placeholder="$t('InternalOrder.No')"
              :remote-method="remoteMethod"
              :loading="loading"
              @change="getOrderInfo">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-tooltip>
        </template>
      </BjDivider>
  
      <!-- 订单信息 -->
      <div class="bj-row" style="border:none;border-bottom: 1px solid #d7d7d7;">
        <!-- 买家收货信息 -->
        <div class="bj-col bj-col-6">
          <div class="bj-form-title">{{ $t('ExternalOrders.newAdd.receivingInformation') }}</div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryName') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.receiverName }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryPhone') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.phone }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel"> {{ $t('ExternalOrders.newAdd.DestinationCountry') }} </div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.country }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel"> {{ $t('ExternalOrders.newAdd.DeliveryState') }} </div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.province }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliverySuburb') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.district }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryPostcode') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.zipCode }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryAddress1') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.deliveryAddress1 }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryAddress2') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.deliveryAddress2 }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.emailAddress') }}</div>
            <div class="bj-form-item-value">
              <span>{{ info.receiverInfoVO.deliveryEmailAddress }}</span>
            </div>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="bj-col bj-col-18">
          <div class="bj-form-title">{{ $t('AddInternalRefundOnlyDoc.Product') }}</div>
          <el-table :data="thirdItemVO" stripe border max-height="251px">
            <!-- <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" /> -->
            <el-table-column prop="innerSkuName" :label="$t('ExternalOrders.newAdd.ProductName')" show-overflow-tooltip align="center" />
            <el-table-column prop="standardSkuCode" :label="$t('ExternalOrders.newAdd.ProductSKU')" show-overflow-tooltip align="center" />
            <el-table-column prop="spuCode" :label="$t('BusinessPurchaseOrder3.Batch')" show-overflow-tooltip align="center" />
            <el-table-column prop="quantity" :label="$t('goodsSku.detail.qty')" show-overflow-tooltip align="center" />
            <el-table-column prop="size" :label="$t('goodsSku.detail.Size')" show-overflow-tooltip align="center" />
            <el-table-column prop="weight" :label="$t('goodsSku.detail.Weight')" show-overflow-tooltip align="center" />
          </el-table>
        </div>
      </div>
  
      <!-- 询价信息 -->
      <BjDivider style="margin-bottom: 0;" class="mt20">{{ $t('SalesOrderEntry.SearchpriceInfo') }}
        <template slot="right">
          <!-- Carton / Pallet -->
          <el-tooltip effect="dark" placement="top" content="Carton / Pallet">
            <BjSelectLov class="mr20" v-model="CartonPalletType" @change="CartonPalletTypeChange" placeholder="Carton / Pallet" :option-list="[{label:'Carton',value:'carton'},{label:'Pallet',value:'pallet'}]" clearable/>
          </el-tooltip>
          <!-- 询价方式 -->
          <el-tooltip effect="dark" placement="top" content="Auto / Manual">
            <BjSelectLov class="mr20" v-model="logiType" @change="logiTypeChange" placeholder="Auto / Manual" :option-list="[{label:'Auto',value:'auto'},{label:'Manual',value:'manual'}]" :clearable="false"/>
          </el-tooltip>
          <!-- 物流公司 -->
          <el-tooltip effect="dark" placement="top" :content="$t('LogisticsRulesTable.header.Logistics')">
            <BjSelectLov class="mr20" v-model="logisticsName" :option-list="LogisticsList" :placeholder="$t('LogisticsRulesTable.header.Logistics')" multiple :clearable="isClear"/>
          </el-tooltip>
          <!-- 托盘高度 -->
          <el-tooltip v-if="logiType=='auto' && palletHShow == true" effect="dark" placement="top" :content="$t('billingPage.palletHeight')">
            <BjInputNumber class="mr20" v-model="palletHeight" :placeholder="$t('billingPage.palletHeight')" :clearable="true"/>
          </el-tooltip>
          <!-- 询价按钮 -->
          <el-button :disabled="cantDoAnything" style="margin-left: 0;margin-right: 16px;" type="primary" @click="onSearch()">{{ $t('SalesOrderEntry.Searchprice') }}</el-button>
        </template>
      </BjDivider>

      <!-- 自动询价 auto -->
      <div v-if="logiType=='auto'" class="bj-row" style="border:none;border-bottom: 1px solid #d7d7d7;">
        <div class="bj-col-24">
          <div class="bj-form-title">{{ $t('OrdinaryOrderMix.LogisticsTable.Details') }}</div>
          <el-table :data="autoPriceList" border max-height="251px" :row-style="tableRowStyle">
            <el-table-column prop="provider" :label="$t('LogisticsRulesTable.header.Logistics')" show-overflow-tooltip align="center" />
            <el-table-column prop="totalPrice" :label="$t('OrderPostage.total')" show-overflow-tooltip align="center">
              <template slot-scope="scope">{{ formatTotalPrice(scope.row) }}</template>
            </el-table-column>
            <el-table-column prop="ratePrice" :label="$t('billingPage.ratePrice')" show-overflow-tooltip align="center" />
            <el-table-column align="center" prop="responseCode" :label="this.$t('InternalSalesOrderDetailsSearchTable.responseCode')">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top" :content="scope.row.responseMsg" :disabled="!scope.row.responseMsg">
                  <div slot="reference" class="name-wrapper">
                    {{ scope.row.responseCode }}
                    <i v-if="scope.row.responseCode=='FAILED'" class="el-icon-warning" style="color:red"></i>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="logisticsType" :label="$t('BjDialogListConfig.Types')" show-overflow-tooltip align="center" />
            <el-table-column prop="packageList.length" :label="$t('WarehouseManagement.form.if')" show-overflow-tooltip align="center" >
              <template slot-scope="scope">
                <span style="color:rgb(39, 55, 204);cursor: pointer;" type="text" @click="onView(scope.row)">{{ scope.row.packageList.length }} </span>
                <span> {{ scope.row.packageType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rateDate" :label="$t('dateText')" show-overflow-tooltip align="center" >
              <template slot-scope="scope">
                <span> {{ scope.row.rateDate | timeFilters(scope.row.rateDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.responseCode=='FAILED' && !['LossOrder','Shipping service has been disabled by the customer.'].includes(scope.row.responseMsg)) || cantDoAnything" type="text" @click="onSelect(scope.row)">{{ $t('selectText') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 手动询价 manual -->
      <div v-if="logiType=='manual'" class="bj-row" style="border:none;border-bottom: 1px solid #d7d7d7;">
        <div class="bj-col-24 mb20">
          <div>
            <!-- 包裹明细 -->
            <div style="float: left;line-height: 2;margin-right: 30px;" class="bj-form-title">{{ $t('OrdinaryOrderMix.LogisticsTable.Details') }}</div>
            <!-- 新增按钮 -->
            <div style="float: right;margin-bottom: 10px;">
              <el-button type="primary" :disabled="cantDoAnything" @click="onAddOne">{{ $t('addText') }}</el-button>
            </div>
          </div>
          <!-- 包裹尺寸列表 form套table formtable-->
          <el-form ref="packageListForm" :model="packageListForm" :rules="rules">
            <el-table :data="packageListForm.packageList" stripe border>
              <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" />
              <el-table-column align="center">
                <template #header><span class="red">*</span> {{ $t('DetailsOfThirdPartySalesOrder.Quantity') }}</template>
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`packageList.${$index}.quantity`" :rules="rules.quantity" style="margin-top:10px !important;">
                    <BjInputNumber v-model="row.quantity" class="full-width" clearable :controls="false" ></BjInputNumber>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template #header><span class="red">*</span> {{ $t('WarehouseManagement.form.Length') }}</template>
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`packageList.${$index}.packageLength`" :rules="rules.packageLength" style="margin-top:10px !important;">
                    <BjInputNumber v-model="row.packageLength" class="full-width" clearable :controls="false" ><template slot="append">cm</template></BjInputNumber>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template #header><span class="red">*</span> {{ $t('WarehouseManagement.form.Width') }}</template>
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`packageList.${$index}.packageWidth`" :rules="rules.packageWidth" style="margin-top:10px !important;">
                    <BjInputNumber v-model="row.packageWidth" class="full-width" clearable :controls="false" ><template slot="append">cm</template></BjInputNumber>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template #header><span class="red">*</span> {{ $t('WarehouseManagement.form.Height') }}</template>
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`packageList.${$index}.packageHeight`" :rules="rules.packageHeight" style="margin-top:10px !important;">
                    <BjInputNumber v-model="row.packageHeight" class="full-width" clearable :controls="false" ><template slot="append">cm</template></BjInputNumber>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template #header> <span class="red">*</span> {{ $t('WarehouseManagement.form.Weight') }}</template>
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`packageList.${$index}.packageWeight`" :rules="rules.packageWeight" style="margin-top:10px !important;">
                    <BjInputMoney v-model="row.packageWeight" class="full-width" clearable :controls="false" ><template slot="append">kg</template></BjInputMoney>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
                <template slot-scope="scope">
                  <el-button :disabled="cantDoAnything" type="text" @click="onDelete(scope.$index)">{{ $t('delText') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <!-- 点击询价按钮后 展示列表 -->
        <div class="bj-col-24 mb20" v-if="listShow">
          <div class="bj-form-title">{{ $t('SalesOrderEntry.PriceSearchResults') }}</div>
          <el-table :data="manualPriceList" border max-height="251px" :row-style="tableRowStyle">
            <el-table-column prop="provider" :label="$t('LogisticsRulesTable.header.Logistics')" show-overflow-tooltip align="center" />
            <el-table-column prop="totalPrice" :label="$t('OrderPostage.total')" show-overflow-tooltip align="center" >
              <template slot-scope="scope">{{ formatTotalPrice(scope.row) }}</template>
            </el-table-column>
            <el-table-column prop="ratePrice" :label="$t('billingPage.ratePrice')" show-overflow-tooltip align="center" />
            <el-table-column align="center" prop="responseCode" :label="this.$t('InternalSalesOrderDetailsSearchTable.responseCode')">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top" :content="scope.row.responseMsg" :disabled="!scope.row.responseMsg">
                  <div slot="reference" class="name-wrapper">
                    {{ scope.row.responseCode }}
                    <i v-if="scope.row.responseCode=='FAILED'" class="el-icon-warning" style="color:red"></i>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="logisticsType" :label="$t('BjDialogListConfig.Types')" show-overflow-tooltip align="center" />
            <el-table-column prop="rateDate" :label="$t('dateText')" show-overflow-tooltip align="center" >
              <template slot-scope="scope">
                <span> {{ scope.row.rateDate | timeFilters(scope.row.rateDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button :disabled="(scope.row.responseCode=='FAILED' && !['LossOrder','Shipping service has been disabled by the customer.'].includes(scope.row.responseMsg)) || cantDoAnything" type="text" @click="onSelect(scope.row)">{{ $t('selectText') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 页面底部信息展示 以及 备注 -->
      <div class="bj-row mt20" style="border:none;">
        <div class="bj-col-4">
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('LogisticsRulesTable.header.Logistics') }}</div>
            <div class="bj-form-item-value">
              <span style="font-weight:bold;font-size: large;">{{ manualRatingVO.provider }}</span>
            </div>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.PaymentTableSubTotalGST') }}</div>
            <div class="bj-form-item-value">
              <span v-if="manualRatingVO.totalPrice" style="font-weight:bold;font-size: large;">${{ manualRatingVO.totalPrice }}</span>
              <span v-else> </span>
            </div>
          </div>
        </div>
        <div class="bj-col-10">
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('billingPage.instruction') }}</div>
            <div class="bj-form-item-value">
              <BjInput :disabled="cantDoAnything" style="width: 90%;" v-model="instructions" :placeholder="$t('billingPage.instruction')" type="textarea" show-word-limit :maxlength="MAX_LENGTH.DEFAULT" />
            </div>
          </div>
        </div>
        <div class="bj-col-10">
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('billingPage.Comments') }}</div>
            <div class="bj-form-item-value">
              <BjInput :disabled="cantDoAnything" style="width: 90%;" v-model="logisticsComment" :placeholder="$t('billingPage.Comments')" type="textarea" show-word-limit :maxlength="MAX_LENGTH.DEFAULT" />
            </div>
          </div>
        </div>
      </div>

      <!-- 下单 -->
      <div class="bj-row mt20" style="border:none;display: flex;justify-content: center;">
        <!-- 手动下单 -->
        <el-button v-permission:BusinessLogisticButton :disabled="canClick" @click="onManualOrder()" type="primary" size="medium" style="width: 200px;">{{$t('billingPage.PlaceOrder')}}</el-button>
        <!-- 打印物流单 -->
        <el-button v-permission:BusinessLogisticButton :disabled="canPrint" @click="onPrint()" type="primary" size="medium" style="width: 200px;">{{$t('billingPage.printLabel')}}</el-button>
      </div>

      <!-- 弹窗 -->
      <el-dialog :visible.sync="dialogVisible" width="500px">
        <el-table :data="dialogList" border script max-height="600px">
          <el-table-column type="index" :label="$t('billingPage.index')" align="center" />
          <el-table-column prop="length" :label="$t('goodsSku.detail.Size')" align="center" >
            <template slot-scope="scope">
              <span type="text">{{ scope.row.length }}*{{ scope.row.width }}*{{ scope.row.height }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </template>
    <script>
    import viewMiXin from '@/utils/view-mixin.js';
    import { orderApi, thirdApi, logisticApi } from '@/api';
  
    const getDefaultForm = () => {
      return {
        receiverInfoVO: {
          receiverName: null,
          phone: null,
          country: null,
          province: null,
          district: null,
          zipCode: null,
          deliveryAddress1: null,
          deliveryAddress2: null,
          deliveryEmailAddress: null,
        },
        thirdItemVO: [],
      };
    };
  
    export default {
      name: 'BusinessOrderBookLogistic',
      components: {},
      mixins: [viewMiXin],
      data() {
        return {
          info: getDefaultForm(),
          // 订单下拉列表
          firstOrderList:[],
          // 外部单号
          outerOrderNo:null,
          // 内部单号
          innerOrderNo:null,
          // 询价方式
          logiType:'auto',
          // 询价方式 判断是否展示 托盘高度
          palletHShow:true,
          // 物流下拉框
          LogisticsList:[],
          // 物流下拉框(all)
          LogisticsListAll:[],
          // 物流下拉框(carton)
          LogisticsCartonList:[],
          // 物流下拉框(pallet)
          LogisticsPalletList:[],
          // 物流公司
          logisticsName:null,
          // 包裹高度
          palletHeight:null,
          // 点击询价按钮后 展示列表 状态
          listShow:false,
          // dialog 展示状态
          dialogVisible:false,
          // dialog 列表
          dialogList:[],
          // 手动询价 返回列表
          manualPriceList:[],
          // 自动询价 返回列表
          autoPriceList:[],
          // 选中数据
          selectedDataRow: null,
          // 表单
          packageListForm:{
            // manual 增删 列表
            packageList:[],
          },
          // 表单校验
          rules: {
            quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            packageLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            packageWidth: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            packageHeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            packageWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          },
          // 页面底部信息
          manualRatingVO:{},
          instructions:null,
          logisticsComment:null,
          // 页面底部下单按钮 disabled 状态
          canClick: true,
          // 页面底部打印按钮 disabled 状态
          canPrint: true,
          // 下单后下半除打印全部置灰 disabled 状态
          cantDoAnything: false,
          // 订单号远程搜索
          options: [],
          loading: false,
          // 询价方式
          CartonPalletType: null,
        };
      },
      computed: {
        receiverInfoVO() {
          return this.info.thirdItemVO || {};
        },
        thirdItemVO() {
          return this.info.thirdItemVO || [];
        },
        isClear() {
          return this.CartonPalletType ? false : true;
        },
      },
      mounted() {
        // 获取所有订单号，支持模糊查询
        this.getOrderChooseList();
        // 获取物流下拉信息
        this.getLogisticsDataList();
      },
      methods: {
        // 计算总价
        formatTotalPrice(row) {
          const freightCharge = Number(row.freightCharge) || 0;
          const fuelCharge = Number(row.fuelCharge) || 0;
          const totalPrice = freightCharge + fuelCharge;
          return totalPrice ? totalPrice.toFixed(2) : '';
        },
        // 获取所有订单号，支持模糊查询
        getOrderChooseList() {
          orderApi.getOrderNoList().then(res => {
            const resp = res.map(item => {
              return { label: item.outerOrderNo, value: item.outerOrderNo, innerOrderNo: item.innerOrderNo}
            });
            this.options = resp;
          });
        },
        // 根据订单号获取订单详情
        getOrderInfo(value) {
          const result = this.options.filter(item => item.label == value)[0]?.innerOrderNo;
          thirdApi.webDetail({outerOrderNo:value}).then(res => {
            this.info = Object.assign({}, this.info, res);
          });
          // 提取内部单号，后续接口使用
          this.innerOrderNo = result
          // 清空下半页面数据
          this.logiTypeChange()
          // 重新搜索订单后，打开按钮限制
          this.cantDoAnything = false
        },
        remoteMethod(query) {
          if (query !== '') {
            this.loading = true;
            orderApi.getOrderNoList({outerOrderNo:query}).then(res => {
              const resp = res.map(item => {
                return { label: item.outerOrderNo, value: item.outerOrderNo, innerOrderNo: item.innerOrderNo}
              });
              this.options = resp;
            });
            this.loading = false;
          } else {
            this.options = [];
          }
        },
        // 获取物流下拉信息
        async getLogisticsDataList(CartonPalletType) {
          logisticApi.getLogisticsBusiness({
              currentPage: 0,
              page: 0,
              pagesize: 999,
              size: 999,
              // type: CartonPalletType || null,
            }).then(res => {
              // 先过滤出 csgEnableFlag 为 true 的数据
              const filteredContent = res.content.filter(item => item.csgEnableFlag === true);
              // 物流下拉框 (初始)
              this.LogisticsList = filteredContent.map(item => {
                return {
                  label: item.name,
                  value: item.name
                };
              });
              // 物流公司默认全选
              this.logisticsName = filteredContent.map(e => e.name);
              // 物流下拉框 (all)
              this.LogisticsListAll = filteredContent.map(item => {
                return {
                  label: item.name,
                  value: item.name
                };
              });
              // 物流下拉框 (carton)
              this.LogisticsCartonList = filteredContent.filter(item => item.type && item.type.includes('carton')).map(item => {
                return {
                  label: item.name,
                  value: item.name
                };
              });
              // 物流下拉框 (pallet)
              this.LogisticsPalletList = filteredContent.filter(item => item.type && item.type.includes('pallet')).map(item => {
                return {
                  label: item.name,
                  value: item.name
                };
              });
          });
        },
        // 新增
        onAddOne(){
          this.packageListForm.packageList.push({
            quantity: null,
            packageLength: null,
            packageWidth: null,
            packageHeight: null,
            packageWeight: null,
          });
        },
        // 单独删除
        onDelete(index) {
          this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            this.packageListForm.packageList.splice(index, 1);
            if(this.packageListForm.packageList.length==0){
              this.listShow = false
            }
            this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
          });
        },
        // Carton/Pallet 变更触发
        CartonPalletTypeChange(n,m){
          if(n == 'carton'){
            this.LogisticsList = this.LogisticsCartonList
            this.logisticsName = this.LogisticsCartonList.map(e=>e.value)
            this.palletHShow = false
            this.palletHeight = 2
          }
          if(n == 'pallet'){
            this.LogisticsList = this.LogisticsPalletList
            this.logisticsName = this.LogisticsPalletList.map(e=>e.value)
            this.palletHShow = true
            this.palletHeight = null
          }
          if(!n){
            this.LogisticsList = this.LogisticsListAll
            this.logisticsName = this.LogisticsListAll.map(e=>e.value)
            this.palletHShow = true
            this.palletHeight = null
          }
        },
        // 询价方式变更
        logiTypeChange(e){
          // 清空 Carton / Pallet
          this.CartonPalletType = null
          // 清空 自动动询价列表
          this.autoPriceList = []
          // 清空 托盘高度
          this.palletHeight = null
          // 显示 托盘高度
          this.palletHShow = true
          
          // 清空 手动动询价列表
          this.manualPriceList = []
          // 清空 自动动询价列表
          this.listShow = false
          // 清空 自动动询价列表
          this.packageListForm.packageList = []

          // 清空底部选中信息避免提交
          this.manualRatingVO = {}
          // 下单按钮 设为不可点击
          this.canClick = true
          // 打印按钮 设为不可点击
          this.canPrint = true
          this.selectedDataRow = null
        },
        // 寻价按钮
        onSearch(){
          if(this.logiType=='auto'){
            const POST_DATA ={
              innerOrderNo: this.innerOrderNo,
              palletHeight: this.palletHeight,
              logisticsCompanyList: this.logisticsName
            }
            // 自动寻价
            if (!this.outerOrderNo) return this.$message.warning(this.$t('chooseText')+' '+this.$t('InternalOrder.No'));
            if (!this.palletHeight) return this.$message.warning(this.$t('inputText')+' '+this.$t('billingPage.palletHeight'));
            orderApi.getAutoSearchPrice(POST_DATA).then(res=>{
              const resp = res.map(item => {
                if (!Array.isArray(item.packageList)) { return { ...item, packageList: [] };}
                return item;
              });
              this.autoPriceList = resp.length? resp : []
            })
          }else if(this.logiType=='manual'){
            const POST_DATA ={
              innerOrderNo: this.innerOrderNo,
              logisticsCompanyList: this.logisticsName,
              packageList: this.packageListForm.packageList,
              palletHeight: this.palletHeight
            }
            // 手动寻价
            this.$refs.packageListForm.validate(valid => {
              if(valid){
                if (!this.outerOrderNo) return this.$message.warning(this.$t('chooseText')+' '+this.$t('InternalOrder.No'));
                if (!this.packageListForm.packageList.length) return this.$message.warning(this.$t('addText')+' '+this.$t('OrdinaryOrderMix.LogisticsTable.Details'));
                this.listShow = true
                orderApi.getManualSearchPrice(POST_DATA).then(res=>{
                  this.manualPriceList = res.length? res : []
                })
              }
            });
          }
        },
        // 查看
        onView(row){
          this.dialogVisible = true
          this.dialogList = row.packageList || []
        },
        // 选中
        onSelect(row){
          if(row.responseMsg == 'Shipping service has been disabled by the customer.'){
            this.$confirm(this.$t('billingPage.PlaceOrderTips'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
              dangerouslyUseHTMLString: true,
              customClass: 'customFileSize-width'
            }).then(() => {
              this.manualRatingVO = row
              this.canClick = false
              this.selectedDataRow = row
            });
          }else{
            this.manualRatingVO = row
            this.canClick = false
            this.selectedDataRow = row
          }
        },
        tableRowStyle({ row }) {
          // 动态返回行样式
          if (this.selectedDataRow && row.provider === this.selectedDataRow.provider) {
            return { background: '#ffcccc' }  // 红色背景
          }
          return {}
        },
        // 下单
        onManualOrder(){
          const POST_DATA ={
            instructions: this.instructions,
            logisticsComment: this.logisticsComment,
            manualRatingList: this.manualPriceList,
            manualRatingVO: this.manualRatingVO
          }
          if(JSON.stringify(this.manualRatingVO) !== '{}'){
            orderApi.createManualOrder(POST_DATA).then(res=>{
              if(res.failed == false){
                this.$message.success(this.$t('toast.operationSuccessText'));
                // 下单按钮置灰
                this.canClick = true
                // 打印按钮开放
                this.canPrint = false
                // 下单后部分按钮置灰
                this.cantDoAnything = true
                // setTimeout(() => {
                //   this.$router.go(0);
                // }, 500);
              }
            })
          }
        },
        // 打印 物流单 
        onPrint(){
          orderApi.getOrderLabel({
            innerOrderNo:  this.innerOrderNo,
          }).then(res => 	{
            console.log(res,'onPrintRes');
            if (!res.failed) {
              this.$message.success(this.$t('screenWMS.ps3'));
              // 从网址转化为文件流 （接口数据， 文件名称  ，文件类型）
              this.urlToFileStream(res.message, this.innerOrderNo, 'application/pdf')
                .then(file => {
                  // console.log('文件流对象:', file);
                  const url = URL.createObjectURL(file);
                  const iframe = document.createElement('iframe');
                  iframe.style.visibility = 'hidden';
                  iframe.style.position = 'absolute';
                  iframe.style.width = '0';
                  iframe.style.height = '0';
                  iframe.src = url;
                  document.body.appendChild(iframe);
                  iframe.onload = () => {
                    iframe.contentWindow.print();
                  };
                  setTimeout(() => {
                    this.outerOrderNo = null
                    this.info = getDefaultForm()
                    this.logiTypeChange();
                  }, 2000);
                })
                .catch(err => console.error('错误:', err))
            }
          })
        },
        // 打印文件前过滤（根据后端返回url获取文件并转化为文件流）
        async urlToFileStream(url, fileName, mimeType) {
          try {
            // 1. 使用 fetch 获取文件数据
            const response = await fetch(url);
            if (!response.ok) { throw new Error(`HTTP 请求失败，状态码: ${response.status}`);}
            // 2. 将响应转换为 Blob 对象
            const blob = await response.blob();
            // 3. 可选：指定文件名和 MIME 类型（如果未提供，则从响应头或 URL 推断）
            const inferredMimeType = mimeType || blob.type || 'application/octet-stream';
            const inferredFileName = fileName || url.split('/').pop() || 'download';
            // 4. 返回 File 对象（Blob 的子类，多了文件名属性）
            return new File([blob], inferredFileName, { type: inferredMimeType });
          } catch (error) {
            console.error('转换失败:', error);
            throw error;
          }
        },
      },
    };
    </script>
    <style lang="scss" scoped>
  .app-container {
    width: 100%;
  }
  .bj-formItemLabel {
    max-width: 20em !important;
  }
  div:not(.bj-page) .bj-row .bj-col {
    width: 49.33%;
  }
  </style>
  <style>
  .customFileSize-width {
    width: 470px; /* 或者任何你想要的宽度 */
  }
  </style>
  
